module.exports = __webpack_public_path__ + "static/media/LOGO SBI (1).5d6d4bb4.PNG";